import { concat, isEmpty, get, cloneDeep } from 'lodash';
import type from './DamHistory.type';

const initialState = {
  damHistoryCount: 0,
  damHistoryList: [],
};

const damHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_DAM_HISTORY_LIST:
      const updatedArry = cloneDeep(setArrayByCase(state.damHistoryList, action.payload));
      return {
        ...state,
        damHistoryList: updatedArry,
        damHistoryCount: action.payload?.totalRecords,
      };
    case type.CLEAR_DAM_REDUCER:
      return {
        ...state,
        damHistoryCount: 0,
        damHistoryList: [],
      };
    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  let newArray;
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    newArray = [...array, ...payload.data];
  } else if (!isEmpty(get(payload, 'searchText'))) {
    newArray = payload.data;
  } else if (get(payload, 'isScrolled')) {
    newArray = concat(array, payload.data);
  } else {
    newArray = payload.data;
  }
  return newArray;
};

export default damHistoryReducer;
